import { ChangeEvent, useState } from 'react';

import styles from './styles.module.css';
import Loader from '../Loader';
import CrossIcon from '@/assets/icons/cross.svg?react';
import SearchIcon from '@/assets/icons/search.svg?react';

interface ListItem {
  value: string;
  label: string;
}

interface SearchInputWithListProps {
  placeholder?: string;
  list: ListItem[];
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  resetSearch?: () => void;
  customClass?: string;
  showLoader?: boolean;
  onItemAction?: (item: ListItem) => void;
  itemActionLabel?: string;
}

const SearchInputWithList = ({
  list = [],
  placeholder = 'Search',
  value = '',
  onChange = () => {},
  resetSearch,
  customClass = '',
  showLoader = false,
  onItemAction,
  itemActionLabel = '+ ADD METRIC'
}: SearchInputWithListProps) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className={`${styles.searchContainer} ${customClass || ''}`}>
      <SearchIcon className={styles.searchIcon} />
      <input
        id={`${placeholder}-search-input`}
        type="text"
        placeholder={placeholder}
        value={value}
        className={styles.searchInput}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
      <div className={styles.inputIcons}>
        {!!value && (
          <span className={styles.icon}>
            {showLoader ? (
              <Loader size="small" />
            ) : (
              resetSearch && (
                <span id={`${placeholder}-cross`} onClick={resetSearch}>
                  <CrossIcon />
                </span>
              )
            )}
          </span>
        )}
      </div>
      {isFocused && list.length > 0 && (
        <div
          className={styles.listContainer}
          onMouseDown={e => e.preventDefault()}
        >
          {list.map((item: ListItem) => (
            <div className={styles.listItem} key={item.value}>
              <span>{item.label}</span>
              {onItemAction && (
                <button
                  className={styles.itemActionButton}
                  onClick={() => onItemAction(item)}
                >
                  {itemActionLabel}
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchInputWithList;
